export const GP_ACCESS_TOKEN_COOKIE = 'gp_at';
export const GP_ACCESS_VERIFICATION_COOKIE = 'gp_at_verify';

export default {};
